import { render } from "./licenseSecrecy.vue?vue&type=template&id=122e6809"
import script from "./licenseSecrecy.vue?vue&type=script&lang=js"
export * from "./licenseSecrecy.vue?vue&type=script&lang=js"

import "./licenseSecrecy.vue?vue&type=style&index=0&id=122e6809&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__